import moment from 'moment'

function getAgeDesc(data) {
  const today = moment(new Date())
  data.forEach(element => {
    if (element.birthDate) {
      for (let i = 0; i < data.length; i++) {
        const newYear = today.diff(data[i].birthDate, 'year')
        const newMonth = today.diff(data[i].birthDate, 'month')
        if (newYear >= 2) {
          data[i].ageDesc = newYear + '岁'
          continue
        }
        if (newYear < 2) {
          data[i].ageDesc = newMonth + '月龄'
          continue
        }
        if (newMonth % 12 === 0) {
          data[i].ageDesc = newYear + '岁'
        } else {
          data[i].ageDesc = newYear + '岁' + (newMonth % 12) + '月龄'
        }
      }
    }
  })
  return data
}

export default getAgeDesc